class DecoderForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.input = this.querySelector('input');
    this.result = this.querySelector('.js-result');
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onFormSubmit(event) {
    event.preventDefault();
    this.decodeID(this.input.value);
  }

  decodeID(id) {
    const lastDigit = id[id.length - 1];
    const result = this.definePartOfTheYearMessage(lastDigit) + " " + this.defineYear(id);
    
    this.changeResultContent(result);
  }

  definePartOfTheYearMessage(index) {
    const firstHalfOfYear = this.dataset.firstHalfOfYear;
    const secondHalfOfYear = this.dataset.secondHalfOfYear;

    return index === '1' ? firstHalfOfYear : (index === '2' ? secondHalfOfYear : '');
  }

  defineYear(id) {
    const year = id.substring(2, 4);
    return `19${year.split("").reverse().join("")}`;
  }

  changeResultContent(content) {
    this.result.innerHTML = content;
  }
}

customElements.define('decoder-form', DecoderForm);
